module.exports = __webpack_public_path__ + "static/badge-enhanced-b316e8e138ca29e2c448ee72ae56b64f.svg";